import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from './app-config.service';
import { ApiService } from './api.service';
import AddCreditCardModel from '../models/add-credit-card-model';
import NetworkTokenModel from '../models/network-token.model';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import camelcaseKeys from 'camelcase-keys';
import { ActionResponse } from '../models/action-response.model';
@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private vistekUrl: string;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,
    private apiService: ApiService,
  ) {
    this.vistekUrl = this.appConfigService.vistekUrl;
  }

  public getPaymentMethod(instrumentIdentifierId: string): Observable<NetworkTokenModel> {
    return this.http
      .get<NetworkTokenModel>(`${this.vistekUrl}/cart/profile/PaymentMethod/${instrumentIdentifierId}`, {
        headers: this.apiService.xsrfHeader,
      }).pipe(
        map(x => camelcaseKeys(x as any))
      );
  }

  public savePaymentMethod(model: AddCreditCardModel): Observable<ActionResponse> {
    return this.http
      .post<ActionResponse>(`${this.vistekUrl}/cart/profile/addPaymentMethod`, model, {
        headers: this.apiService.xsrfHeader,
      }).pipe(
        catchError(_ => of({ isSuccess: false, error: 'Failed to save payment method. Please try again later.' })),
        map(x => camelcaseKeys(x))
      );
  }

  public changeDefaultPaymentMethod(instrumentIdentifierId: string, isSettingToDefault: boolean): Observable<ActionResponse> {
    return this.http
      .post<ActionResponse>(`${this.vistekUrl}/cart/profile/changeDefaultPaymentMethod/${instrumentIdentifierId}`, isSettingToDefault, {
        headers: this.apiService.xsrfHeader,
      }).pipe(
        catchError(_ => of({ isSuccess: false, error: 'Failed to change default payment method. Please try again later.' })),
        map(x => camelcaseKeys(x))
      );
  }
}
